import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'removeEmptyKey',
    pure: false,
    standalone: false
})
export class RemoveEmptyKeyPipe implements PipeTransform {
  transform(items: any[]): any {
    if (!items) {
      return items;
    }
    return items.filter(item => item.key);
  }
}